import React from 'react';
import { CSSReset } from '@chakra-ui/react';

import Hero from '../Components/Home/Hero';
import Overview from '../Components/Home/Overview';
import VisionMission from '../Components/Home/VisionMission';
import Services from '../Components/Home/Services';
import Contact from '../Components/Home/Contact';
import Careers from '../Components/Home/Careers';
import ScrollToTopButton from '../Components/ScrollToTopButton';

const Home = () => {
  return (
    <>
      <CSSReset />
      <Hero />
      <Overview />
      <VisionMission />
      <Services />
      <Careers />
      <Contact />
      <ScrollToTopButton />
    </>
  );
};

export default Home;